import { UltimaVisita } from "../../../../types/empresa";
import { DatosGeneralesText } from "../../../../components/ui/DatosGeneralesText"; 
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import AccessTimeFilledRoundedIcon from '@mui/icons-material/AccessTimeFilledRounded';
import CorporateFareRoundedIcon from '@mui/icons-material/CorporateFareRounded';
import FollowTheSignsRoundedIcon from '@mui/icons-material/FollowTheSignsRounded';
import KeyboardDoubleArrowDownRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowDownRounded';
import KeyboardDoubleArrowUpRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowUpRounded';

interface Props {
    ultimaVisita?: UltimaVisita;
}

export function EmpresaUltimaVisita({ ultimaVisita }: Props) {

    const iconSize = 20;

    return (
        <>
        {ultimaVisita == null
        ?
        <div>
            <p className="text-center font-semibold my-2">Sin información de última visita</p>
        </div>
        :
        <div>
            <DatosGeneralesText 
                icon={<CalendarMonthRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Fecha: "}
                text={ultimaVisita?.fecha}/>

            <div className="flex gap-x-4">
                <DatosGeneralesText 
                    icon={<KeyboardDoubleArrowDownRoundedIcon sx={{ height: iconSize, width: iconSize, color: "green" }}/>}
                    label={"Empezó: "}
                    text={ultimaVisita?.horaInicio}/>
                <DatosGeneralesText 
                    icon={<KeyboardDoubleArrowUpRoundedIcon sx={{ height: iconSize, width: iconSize, color: "red" }}/>}
                    label={"Terminó: "}
                    text={ultimaVisita?.horaFin}/>
            </div>

            <DatosGeneralesText 
                icon={<Person2RoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Prospectadora: "}
                text={ultimaVisita?.nombreProspectador}/>
            <DatosGeneralesText 
                icon={<FollowTheSignsRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Tipo de visita: "}
                text={ultimaVisita?.tipoVisita}/>
            <DatosGeneralesText 
                icon={<CorporateFareRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Tipo de empresa: "}
                text={ultimaVisita?.tipoEmpresa}/>
            <DatosGeneralesText 
                icon={<AccessTimeFilledRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                label={"Turno: "}
                text={ultimaVisita?.turno}/>
            <DatosGeneralesText 
                label={"Total de intenciones: "}
                text={ultimaVisita?.totalIntenciones}/>

            <div className="mx-4 text-center">
                <div className="flex gap-2 justify-between font-bold">
                    <p>Vendedor</p>
                    <p>Intenciones</p>
                </div>
                <ul>
                    {ultimaVisita?.intencionesVendidas.length == 0 || ultimaVisita?.intencionesVendidas == null
                    ? <div className="py-3">
                        <p className="font-semibold text-center">Sin intenciones vendidas</p>
                    </div>
                    : ultimaVisita?.intencionesVendidas.map((intencion, index) => (
                    <li key={index} className="flex gap-2 justify-between">
                        <p>{intencion.nombreVendedor}</p>
                        <p> - </p>
                        <p>{intencion.intenciones}</p>
                    </li>

                    ))}
                </ul>
            </div>

        </div>
        }</>
    );
}
